import styled from 'styled-components';
import AntEmpty from 'antd/lib/empty';

export const Empty = styled(AntEmpty)`
  font-family: 'Museo Sans Cyrl';
`;
